import { useLocation, useNavigate } from 'react-router';
import PhoneIcon from '@mui/icons-material/Phone';
import { useSelector } from 'react-redux';
import './HeaderMainPage.css';
import logoMainPage from '~/assets/logo.png';
import accountLogo from '~/assets/Ico_Account.svg';
import logoOnlineMainPage from '~/assets/mainPage/header/Logo_OnLine.svg';
import { useAppDispatch } from '~/store/appDispatch.ts';
import type { RootState } from '~/store/store.ts';
import { logout } from '~/store/users/thunks.ts';
import useGetUserRole from '~/hooks/useGetUserRole.ts';

const HeaderMainPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state: RootState) => state.users.token);
  const { isClientLogin } = useGetUserRole();
  const isCovenantsPath =
    location.pathname.startsWith('/covenants') || location.pathname.startsWith('/covenant');
  const hideAccountIcon = isCovenantsPath && Boolean(isClientLogin || token);

  const handleLogout = async () => {
    try {
      await dispatch(logout());
      navigate('/services');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <header className="main-page-header">
      <div className="main-page-header-container">
        <img src={logoMainPage} alt="logo" className="main-page-logo" />
      </div>

      <div className="main-page-online-logo-content">
        <div className="online-logo-container">
          <img src={logoOnlineMainPage} alt="online_main_page" className="online-logo" />
        </div>
      </div>
      <div className="main-page-button-content">
        {hideAccountIcon ? (
          <div className="covenants-phone-contact">
            <PhoneIcon className="covenants-phone-icon" />
            <span className="covenants-phone-text">0-800-50-44-50</span>
          </div>
        ) : (
          <img src={accountLogo} alt="account" className="account_logo" />
        )}
        {token ? (
          <button type="button" className="main-page-button" onClick={handleLogout}>
            Вийти
          </button>
        ) : (
          <button type="button" className="main-page-button" onClick={() => navigate('/sign-in')}>
            Увійти
          </button>
        )}
      </div>
    </header>
  );
};

export default HeaderMainPage;
